<div
  class="mainContainer d-flex justify-content-between align-items-center gap-3 flex-wrap wrap"
  style="background-color: var(--color-gray-60)"
>
  <div class="d-flex flex-column">
    <h4 class="headingBL title">
      Stories of Transformation<span> From Virsa</span>
    </h4>
    <div style="height: fit-content">
      <iframe
        src=" https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/tagore_international_school_students_feedback.mp4"
        width="656"
        height="400"
        class="web-video"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      ></iframe>
      <iframe
        src="https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/tagore_international_school_students_feedback.mp4"
        width="330"
        height="185"
        class="mobile-video"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      ></iframe>
    </div>
    <div class="aboutVideo">
      Students of TIS, VasantVihar Delhi<br /><span
        >(Tagore International School)</span
      >
    </div>
  </div>
  <div class="d-flex flex-column gap-3 align-items-center px-3 py-3">
    <div
      class="d-flex flex-row align-items-center cardWrap point"
      *ngFor="let testimonial of testimonials"
      [style.background-color]="testimonial.color"
      (click)="openDialog(testimonial.name1, testimonial.videoLink)"
    >
      <div class="imgWrap">
        <img loading="lazy" class="img" [src]="testimonial.image" />
      </div>
      <div class="d-flex flex-column gap-2 detailsWrap">
        <div class="d-flex flex-row justify-content-center gap-2 textWrap">
          <div class="quoteWrap">
            <img
              loading="lazy"
              class="quote"
              src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_quote.png"
            />
            <div class="line"></div>
          </div>
          <p class="details">
            {{ testimonial.details }}
          </p>
        </div>
        <h5 class="info">
          {{ testimonial.name1 }} <span>{{ testimonial.name2 }}</span>
        </h5>
      </div>
    </div>
  </div>
</div>
